export default "__VITE_ASSET__2a33e9d1__"